import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Price = ({ raceDate, courseName, raceTime, horseName, raceId, raceDateTime }) => (
    <div className="js-PC-runnerRow">
        <div
            className={classNames(
                'js-diffusionHorsesList',
                'js-bestOddsPriceContainer',
                'PC-bestOddsContainer',
            )}
            data-diffusion-racedate={raceDate}
            data-diffusion-coursename={courseName}
            data-diffusion-racetime={raceTime}
            data-diffusion-horsename={horseName}
            data-diffusion-race-id={raceId}
            data-card-race-date-time={raceDateTime}
        >
            <div
                className={classNames(
                    'ui-priceBtn_noPrice',
                    'ui-btn',
                    'js-diffusionPriceValue',
                    'js-betHandler',
                    'js-runnerPrice',
                    'js-runnerPriceBestOdds',
                    'tn-priceButton',
                )}
            />
        </div>
    </div>
);

Price.propTypes = {
    raceDate: PropTypes.string,
    courseName: PropTypes.string,
    raceTime: PropTypes.string,
    raceDateTime: PropTypes.string,
    horseName: PropTypes.string.isRequired,
    raceId: PropTypes.number.isRequired,
};

export default Price;



// WEBPACK FOOTER //
// ./src/js/Price/index.js